<template>
    <div class="sidebar-icon-wrapper">
        <div v-if="hasIcon">
            <i :class="'icon bi bi-' + item.icon" :key="item.icon" v-if="item.type == 'platform-app' || item.type == 'component'"></i>
            <img :src="item.icon" v-if="item.type == 'forge-app'" class="sidebar-forge-icon"/>
            <img :src="iconValue" v-if="item.type == 'integration' && iconType == 'img'" class="sidebar-integration-icon"/>
            <i v-if="item.type == 'integration' && iconType == 'b-icon'" :class="'bi bi-' + iconValue" class="sidebar-integration-icon"></i>
        </div>
        <span v-else class="sidebar-icon-placeholder">{{ text }}</span>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },

    computed: {
        text() {
            const t = this.$translateLabel(this.item.label, this.item.name)
            return t[0].toUpperCase()
        },

        hasIcon() {
            if (this.item.type === 'integration') {
                return this.item.template && this.item.template.icon
            }
            return this.item.icon
        },

        iconType() {
            if (this.item.type !== 'integration' || !this.item.template || !this.item.template.icon) {
                return null
            }
            
            const icon = this.item.template.icon
            
            if (icon.includes(':')) {
                const part = icon.split(':')
                return part[0]
            }
            
            if (!icon.includes(' ') && !icon.startsWith('/')) {
                return 'b-icon'
            }
            
            if (icon.startsWith('/') || icon.startsWith('http')) {
                return 'img'
            }
            
            return 'icon'
        },

        iconValue() {
            if (this.item.type !== 'integration' || !this.item.template || !this.item.template.icon) {
                return ''
            }
            
            const icon = this.item.template.icon
            
            if (icon.includes(':')) {
                return icon.replace(`${this.iconType}:`, '')
            }
            
            return icon
        }
    }
}
</script>

<style scoped lang="scss">
.sidebar-icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    flex-shrink: 0;
    position: relative;

    .icon {
        font-size: 16px;
        color: inherit;
    }

    .sidebar-forge-icon,
    .sidebar-integration-icon {
        width: 20px;
        height: 20px;
        object-fit: contain;
        border-radius: 3px;
    }

    .sidebar-integration-icon.bi {
        font-size: 16px;
        width: auto;
        height: auto;
    }

    .sidebar-icon-placeholder {
        font-size: 12px;
        font-weight: 600;
        color: var(--text-secondary);
    }
}
</style>
